import React, { useEffect, useState } from 'react'
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";


// images
import hero from "./Images/hero.svg";
import CommitteeTreeimage from "./Images/CommitteeTreeimage.svg"
import counterbg from "./Images/counterbg.svg";
import countericon1 from "./Images/countericon1.svg";
import countericon2 from "./Images/countericon2.svg";
import countericon3 from "./Images/countericon3.svg";
import countericon4 from "./Images/countericon4.svg";

//icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import Birthday from './Birthday';
import axios from 'axios';


interface datastructure{
  title:string,
  content:string,
  id:number,
  section_name:String,
  icon:string,
}

interface banner{
  title:string,
  content:string,
  id:number,
  image:string,
  pageName:String,
}

const RMBJaipur = () => {

  const[bannerdata, setBannerdata] = useState<banner[]>([]);
  const[pagedata, setPagedata] = useState<datastructure[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          "https://rmbbackend.rmbjaipur.com/auth/rmbjaipur",{
            
      });

        console.log('rmbjaipur data',response.data)
        setPagedata(response.data);
        console.log("rmbjaipur data in a array",pagedata);
      } catch (error) {
        console.error("rmbjaipur Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          "https://rmbbackend.rmbjaipur.com/auth/aboutbanner",{
            
      });

        console.log('banner data',response.data)
        setBannerdata(response.data);
        console.log("banner data in a array",bannerdata);
      } catch (error) {
        console.error("banner Not Found:", error);
      }
    };

    fetchData();
  }, []);

  
  return (
    <div>
 <Header />
 {bannerdata.filter((items)=>items.pageName == 'RMBJaipur').map((items)=>(
   <div
   className="w-full h-[451px] relative"
   style={{
    backgroundImage: `url(https://rmbbackend.rmbjaipur.com/${items.image.replace(/\\/g, '/')})`,
     backgroundPosition: "center",
     backgroundSize: "cover",
   }}
 >
   {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
   <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
     <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
     {items.title}{" "}
     </h2>
     <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
       {items.content}
     </p>
     <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
       <a
         className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
         href="/"
       >
         {" "}
         <FaHome />
         Home
       </a>
       <a
         className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
         href="/rmbjaipur"
       >
         {" "}
         <IoIosArrowForward />
         RMB Jaipur{" "}
       </a>
     </div>
   </div>
 </div>
 ))}
     
     
      <div className='bg-[#1E2A3A] py-14 px-[8%] flex flex-col'>
    <h2 className='text-[#F1F4F9] text-[39px] font-semibold text-center '>Leadership Team and Working  <span className='text-[#FDBC12]'>Committee Tree</span></h2>
      <img  src={CommitteeTreeimage} alt="" />
      </div>
      {pagedata.filter((items)=>items.section_name === 'General Membership Policy').map((item)=>(
        <div className="bg-[#101729] py-14 px-[8%]">
       <h2 className="text-center text-[#F1F4F9] text-[39px] font-semibold">
  {item.title.split(' ')[0]} <span className="text-[#FDBC12]">  
    {item.title.substring(item.title.split(' ')[0].length + 1)}
  </span>
</h2>
       <div className="bg-[#1E2A3A] p-10 rounded-xl mt-10">
       <ol className="list-decimal text-[#94A2B8] text-[400] ml-4 mt-4 flex flex-col gap-y-5">
        {item.content.split('</br>').map((list)=>(
          <li>{list}</li>
        ))}
        </ol>
       </div>
      </div>
      ))}
      
      <div
        className="px-[8%] py-[80px] bg-cover bg-center relative flex flex-wrap items-center justify-between w-[100%] gap-y-5 "
        style={{ backgroundImage: `url(${counterbg})` }}
      >
        <div className="absolute inset-0  bg-[#070a13] bg-opacity-90"></div>
        {pagedata.filter((item)=>item.section_name === 'box').map((items)=>(
          <div className="bg-[#101729] border border-[#465468] p-5 relative z-10 flex flex-col lg:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
          <img className="w-[72px]" src={`https://rmbbackend.rmbjaipur.com/${items.icon}`} alt="" />
          <h2 className="text-[#FFFFFF] text-[39px] font-bold">{items.title}+</h2>
          <p className="text-[#FFFFFF] text-[16px] text-center">
            {items.content}
          </p>
        </div>
        ))}
       
      </div>
      <Footer />
    </div>
  )
}

export default RMBJaipur